import axios from "axios";
import moment from "moment";
import qs from "qs";
export const headerReq = {
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        // 'Access-Control-Allow-Origin': 'http://localhost:3000'
    }
}

export const getQueryStrinngFromObject = (data) => {
    const obj = {}
    Object.entries(data).map(([key, value]) => {
        if(value) {
            obj[key] = value;
        }
    });

    return Object.entries(obj).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
}

export const getElasticFormatedFromObject = (data, type) => {
    
    const obj = {}
    

    Object.entries(data).map(([key, value]) => {
        if(value) {
            obj[key] = value;
        }
    });

    const formatedObj = {
        "documentType" : type,
        "searchWith" : obj,
        "operator" : "AND"
    }

    return formatedObj;
    
}


export const checkvalidationFromvalues = () => {
    
}

export const requestDeleteApiCall = async(url) => {
    
    const headerReq = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }

    try {
        const response = await axios.delete(url,headerReq);
        return response;
    } catch (error) {
        return error;
    }
    
}

export const getOrderRequestData = async(url) => {
    const headerReq = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }
    
    try {
        const response = await axios.get(url, headerReq);
        return response;
    } catch(error) {
        // return error;
        return  { propererror: error?.response, status: 'error'}
    }
}
 
export const getRequestData = async (url) => {
    const headerReq = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }
    
    try {
        const response = await axios.get(url, headerReq);
        return response;
    } catch(error) {
        return error;
    }
}

export const getRequestDataWithoutToken = (url) => {
    const headerReq = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }
    
    try {
        const response = axios.get(url, headerReq);
        return response;
    } catch(error) {
        return error;
    }
}

export const createOrderRequestData = async (data, url, isFile=false) => {
    const headerReq = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }

    const FileheaderReq = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }
    
    try {
        const response = await axios.post(url,data, !isFile ? headerReq : FileheaderReq);
        return response;
    } catch(error) {
        return  { propererror: error?.response, status: 'error'}
    }
}


export const updateOrderRequestData = async(data, url) => {
    const headerReq = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }
    
    try {
        const response = await axios.put(url,data, headerReq);
        return response;
    } catch(error) {
        // return error;
        return  { propererror: error?.response, status: 'error'}
    }
}


export const createRequestData = async (data, url, isFile=false) => {
    const headerReq = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }

    const FileheaderReq = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }
    
    try {
        const response = await axios.post(url,data, !isFile ? headerReq : FileheaderReq);
        return response;
    } catch(error) {
        return  { propererror: error?.response, status: 'error'}
    }
}

export const updateRequestData = async (data, url, isFile=false) => {
    const headerReq = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }
    const FileheaderReq = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }
    try {
        const response = await axios.put(url,data, !isFile ? headerReq : FileheaderReq);
        return response;
    } catch(error) {
        return  { propererror: error?.response, status: 'error'}
    }
}


export const searchRequestData = async (queryparams, url, isFile=false) => {
    const headerReq = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }
    const FileheaderReq = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
    }
   const RequestHead = !isFile ? headerReq :FileheaderReq
    try {
        const response = await axios.get(url,{ ...RequestHead, ...queryparams});
        return response;
    } catch(error) {
        return  { propererror: error?.response, status: 'error'}
    }
}

export const putRequest = async (url, params) => {
  try {
    return await axios.put(url, null, {
      params,
      paramsSerializer: p =>
        qs.stringify(p, { arrayFormat: "repeat" }),
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
  } catch (error) {
    return { error: error?.response };
  }
};

export const dateFormatting =(date)=>{
return moment(date).format("YYYY-MM-DD")
}

export const isValidEmail = (email)=>{
const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
return regex.test(email)
}

export const isValidPhoneNumber = (value) => {
  const strValue = String(value);
  return /^[0-9]{10}$/.test(strValue);
};



//To check if pocName is non-empty
const isNonEmpty = (value) => typeof (value === "string") && value?.trim()?.length > 0;

//To check validity of communication Values
const phoneEmailCheck = (userDetail) => {
  const phoneValid = !userDetail?.phone || userDetail.phone.length === 0 ? true : isValidPhoneNumber(userDetail.phone);

  const telephoneValid = !userDetail?.telephone || userDetail.telephone.length === 0 ? true : isValidPhoneNumber(userDetail.telephone);

  const emailValid = !userDetail?.email || userDetail.email.length === 0 ? true : isValidEmail(userDetail.email);

  return phoneValid && telephoneValid && emailValid;
};

const pocPhoneEmailCheck = (userDetail) => {
  const phoneValid = !userDetail?.pocPhone || userDetail.pocPhone.length === 0 ? true : isValidPhoneNumber(userDetail.pocPhone);
  const emailValid = !userDetail?.pocEmail || userDetail.pocEmail.length === 0 ? true : isValidEmail(userDetail.pocEmail);
  return phoneValid && emailValid
};

//To check validity of poc Values
const pocPhoneEmailNonEmptyCheck = (userDetail) => {
  const phoneValid = isValidPhoneNumber(userDetail?.pocPhone || "");
  const emailValid = isValidEmail(userDetail?.pocEmail || "");
  const firtNameValid = isNonEmpty(userDetail?.pocFirstName);
  const lastNameValid = isNonEmpty(userDetail?.pocLastName);

  return phoneValid && emailValid && firtNameValid && lastNameValid;
};

//Phone and email non-empty check
const phoneEmailNonEmptyCheck = (userDetail) => {
  const phoneValid = isValidPhoneNumber(userDetail?.phone || "");
  const emailValid = isValidEmail(userDetail?.email || "");
  const telephoneValid = !userDetail?.telephone || userDetail.telephone.length === 0 ? true : isValidPhoneNumber(userDetail.telephone);

  return phoneValid && emailValid && telephoneValid;
};



//To check if client while creation and updation have valid mandatory values.
export const clientValidation = (userDetail) => {
  return (
    isNonEmpty(userDetail?.clientCode) &&
    isNonEmpty(userDetail?.name) &&
    isNonEmpty(userDetail?.tradeName) &&
    isNonEmpty(userDetail?.constitutionOfBusiness) &&
    phoneEmailNonEmptyCheck(userDetail) &&
    pocPhoneEmailCheck(userDetail)
  );
};

export const userValidation = (userDetail)=>{
    return (
    isNonEmpty(userDetail?.title) &&
    isNonEmpty(userDetail?.firstName) &&
    isNonEmpty(userDetail?.lastName) &&
    isNonEmpty(userDetail?.status) &&
    userDetail?.selectedCompany &&
    userDetail?.validFrom &&
    userDetail?.validTo &&
    phoneEmailNonEmptyCheck(userDetail)
    )
}

export const leadValidation = (leadDetails)=>{
    return (
    isNonEmpty(leadDetails?.title) &&
    isNonEmpty(leadDetails?.firstName) &&
    isNonEmpty(leadDetails?.lastName) &&
    phoneEmailNonEmptyCheck(leadDetails)&&
    pocPhoneEmailCheck(leadDetails)
    )}
export const customerValidation = (userDetail)=>{
    return (
    isNonEmpty(userDetail?.title) &&
    isNonEmpty(userDetail?.firstName) &&
    isNonEmpty(userDetail?.lastName) &&
    isNonEmpty(userDetail?.status) &&
    phoneEmailNonEmptyCheck(userDetail)&&
    pocPhoneEmailCheck(userDetail)
)}
export const vendorValidation =(vendorDetail)=>{
    return (
    isNonEmpty(vendorDetail?.name) &&
    isNonEmpty(vendorDetail?.status) &&
    pocPhoneEmailCheck(vendorDetail) &&
    phoneEmailNonEmptyCheck(vendorDetail)
    )
}
    export const getEntityList = (inputSearch) => {

        var entitiesList = [];

        if(inputSearch?.entity == "LEAD_SIDEBAR_MENU") {
            
            entitiesList = ["Lead","LeadFollowup","LeadProduct"];
        
        }

        if(inputSearch?.entity == "CUSTOMER_SIDEBAR_MENU") {
            
            
            entitiesList = ["Customer"];
        
        }

        if(inputSearch?.entity == "ORDER_SIDEBAR_MENU") {
            
            entitiesList = ["SalesOrder", "SalesOrderProduct"];
        
        }

        if(inputSearch?.entity == "INVOICE_SIDEBAR_MENU") {
            
            entitiesList = ["Invoice", "InvoiceProduct"];
        
        }

        if(inputSearch?.entity == "VENDOR_SIDEBAR_MENU") {
            
            entitiesList = ["Vendor"];
        
        }

        if(inputSearch?.entity == "PRODUCT_SIDEBAR_MENU") {
                
            entitiesList = ["Product"];
        
        }

        if(inputSearch?.entity == "CONFIGURATION_USER_MENU") {
                
            entitiesList = ["User","UserRole"];
        
        }

        if(inputSearch?.entity == "CONFIGURATION_CLIENT_MENU") {
                
            entitiesList = ["Client"];
        
        }

        return entitiesList;
}

export const handleCellEditStart = () => {
    setTimeout(() => {
      const input = document.querySelector('.MuiDataGrid-cell--editing');
      if (input) {
        input.focus(); 
        const length = input.value.length;
        input.setSelectionRange(length, length); 
      }
    }, 10);

}

export const downloadDocument = async (documentId) => {
  try {
    const response = await getDocumentBlob(documentId)
    const disposition = response.headers["content-disposition"];
    const contentType = response.headers["content-type"];
    
    
    let filename = "file";
    
    if (disposition) {
      const exactMatch = disposition.match(/filename="([^"]*)"/);
      if (exactMatch && exactMatch[1]) {
        filename = exactMatch[1];
      }else {
        const parts = disposition.split('filename=');
        if (parts.length > 1) {
          filename = parts[1].replace(/^"|"$/g, '').split(';')[0].trim();
        }
      }
    }

    const blobUrl = window.URL.createObjectURL(
      new Blob([response.data], { type: contentType })
    );
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    setTimeout(() => {
      window.URL.revokeObjectURL(blobUrl);
    }, 100);
    
    return true;
  } catch (error) {
    return false;
  }
};
export const getDocumentAsBlobUrl = async (documentId) => {
  if (!documentId) return null;
  try {
    const response = await getDocumentBlob(documentId)
    const blob = response.data;
    const contentType = response.headers["content-type"] || blob.type || "application/octet-stream";
    const blobUrl = window.URL.createObjectURL(new Blob([blob], { type: contentType }));
    return blobUrl;
  } catch (err) {
    return null;
  }
}

export const getDocumentBlob = (documentId) => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}documents/download/${documentId}`,
    {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }
  );
}